// extracted by mini-css-extract-plugin
module.exports = {"highlightedText":"HighlightedText-module--highlightedText--3YrLT"};